import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'customer-erasure-method',
    pluginName: 'CUSTOMER_ERASURE_METHOD',
    entityName: 'CUSTOMER_ERASURE_METHOD',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch customer erasure methods action creators
export const fetchCustomerErasureMethodInit = () => {
    return crudActions.fetchInit();
};
export const fetchCustomerErasureMethodStart = () => {
    return crudActions.fetchStart();
};
export const fetchCustomerErasureMethodSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchCustomerErasureMethodFail = () => {
    return crudActions.fetchFail();
};
export const fetchCustomerErasureMethodCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchCustomerErasureMethodStart());
        try {
            let countRes = await rest.post("/customer-erasure-method/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchCustomerErasureMethodSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchCustomerErasureMethodFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch securaze standards."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchCustomerErasureMethodFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch securaze standards."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchCustomerErasureMethod = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchCustomerErasureMethodStart());
        try {
            let listRes = await rest.post("/customer-erasure-method/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchCustomerErasureMethodSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchCustomerErasureMethodFail());
            return []

        } catch (error) {
            dispatch(fetchCustomerErasureMethodFail());
            return []
        }
    }
}

// Load customer erasure method action creators
export const loadCustomerErasureMethodInit = () => {
    return crudActions.loadInit();
};
export const loadCustomerErasureMethodStart = () => {
    return crudActions.loadStart();
};
export const loadCustomerErasureMethodSuccess = loadedCustomerErasureMethod => {
    return crudActions.loadSuccess(loadedCustomerErasureMethod);
};
export const loadCustomerErasureMethodFail = error => {
    return crudActions.loadFail(error);
};
export const loadCustomerErasureMethod = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};


// Edit customer erasure method action creators
export const editCustomerErasureMethodInit = () => {
    return crudActions.editInit();
};
export const editCustomerErasureMethodStart = () => {
    return crudActions.editStart();
};
export const editCustomerErasureMethodSuccess = editedCustomerErasureMethod => {
    return crudActions.editSuccess(editedCustomerErasureMethod);
};
export const editCustomerErasureMethodFail = error => {
    return crudActions.editFail(error);
};

export const editCustomerErasureMethod = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editCustomerErasureMethodStart());
        try {
            let res = await rest.post('/customer-erasure-method/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editCustomerErasureMethodSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated customer securaze standard.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editCustomerErasureMethodFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit securaze standard."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit securaze standard."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editCustomerErasureMethodFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const listSupportedClientTypes = (data, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/supported-client-type/list', data, options);
            if (res.data && res.data.succeeded) {
                let supportedClientTypes = [];
                for (var supportedClientType of res.data.result.data) {
                    supportedClientTypes.push({ value: supportedClientType.SupportedClientTypeID, label: `${supportedClientType.Name}` });
                }
                return supportedClientTypes;
            } else {
                if (res && res.canceled) {
                    return [];
                }
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list supported client types."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}
